<template>
  <v-container>
    <!-- Vuetify styling seems to be ignored for print pages, so we have to use old styling methods -->
    <div id="qrcodePrint" class="print">
      <div
          v-for="(child, i) in qrcodes"
          :key="i"
          align="center"
      >
        <h1>
          {{ child.name }}
        </h1>
        <VueQrcode
            :value = "getPublicURL() + '/' + child.code"
            :scale = "8"
        />
        <div>
          {{ child.customerName }}
        </div>

        <div style="padding-top:100px"></div>
        <div
            v-if="i % 2 == 1 && (i + 1) != qrcodes.length"
            style="break-before: page"
        ></div>
      </div>
    </div>
  </v-container>
</template>

<script>
import VueQrcode from "vue-qrcode";
import QRCodeService from "@/modules/book/services/qrcode-service";

export default {
  name: "QRCodePrint",
  data() {
    return {
      qrcodes: []
    }
  },
  components: {
    VueQrcode
  },
  methods: {
    updateData(data) {
      this.qrcodes = data;
    },
    print() {
      // Get HTML to print from element
      const prtHtml = document.getElementById('qrcodePrint').innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    getPublicURL(){
      return QRCodeService.getPublicURL();
    }
  }
}
</script>

<style type="text/css">
/** For the print text, hide the information and only show it in print-mode **/
.print {
  display: none;
}
@media print {
  .print {
    display: initial;
  }
}
</style>
